export enum RutType {
  PERSON = 'Natural Person',
  COMPANY = 'Legal Entity',
  UNKNOWN = 'Unknown'
}

/**
 * Validates a Chilean RUT and identifies if it belongs to a person or a company.
 * @param rutStr The RUT string (e.g., "12.345.678-5" or "123456785")
 */
export const validateAndIdentifyRut = (rutStr: string) => {
  // 1. Clean the string
  const cleanRut = rutStr.replace(/[^0-9kK]/g, '').toUpperCase();
  if (cleanRut.length < 2) return { isValid: false, type: RutType.UNKNOWN };

  const body = cleanRut.slice(0, -1);
  const dv = cleanRut.slice(-1);

  // 2. Modulo 11 Validation
  let sum = 0;
  let multiplier = 2;

  for (let i = body.length - 1; i >= 0; i--) {
    sum += parseInt(body[i]) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const expectedRes = 11 - (sum % 11);
  let expectedDv = '';
  if (expectedRes === 11) expectedDv = '0';
  else if (expectedRes === 10) expectedDv = 'K';
  else expectedDv = expectedRes.toString();

  const isValid = dv === expectedDv;

  // 3. Identification Logic
  const bodyNum = parseInt(body);
  const type = bodyNum > 50000000 ? RutType.COMPANY : RutType.PERSON;

  return { 
    isValid, 
    type, 
    formatted: `${body}-${dv}`,
    body: bodyNum,
    dv: dv
  };
};